import { render } from "./Configs.vue?vue&type=template&id=7942d20a"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mw/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__